import type { MappedProductBoxProps } from '@ori/product-box';
import type { Dispatch, SetStateAction } from 'react';

export interface GetSetLoadedProductsCallbackParams {
  lastUpdated: string;
  setAmountToLoad?: Dispatch<SetStateAction<number>> | undefined;
}

export const getSetLoadedProductsCallback =
  ({ lastUpdated, setAmountToLoad }: GetSetLoadedProductsCallbackParams) =>
  (prevProducts: MappedProductBoxProps[]) => {
    if (
      setAmountToLoad === undefined ||
      prevProducts.some((product) => product.code === lastUpdated)
    ) {
      setAmountToLoad?.((prevAmount) => (prevAmount ? prevAmount - 1 : 0));

      return prevProducts.filter((product) => product.code !== lastUpdated);
    }

    return prevProducts;
  };
